import { useMutation, useQueryClient } from "@tanstack/react-query";
import { runCompassActions, reorderActions } from "../services/compass.service";
import type { ICompasAIActionsRequest, IReorderActionsRequest } from "../types/compass.types";

/**
 * Hook to run compass actions (single or bulk)
 */
export const useRunCompassActions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      requests,
    }: {
      requests: ICompasAIActionsRequest | ICompasAIActionsRequest[];
      documentId: string;
    }) => runCompassActions(requests),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["compass-chat-history", variables.documentId],
      });
      // Amelia Discuss is document-keyed; refetch even if the queue WS is down.
      queryClient.invalidateQueries({
        queryKey: ["chatHistory", variables.documentId],
      });
    },
    onError: (error) => {
      console.error("Failed to run compass actions:", error);
    },
  });
};

/**
 * Hook to reorder actions within a group
 */
export const useReorderActions = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: IReorderActionsRequest) => reorderActions(payload),
    onSuccess: (_, variables) => {
      // Invalidate compass chat history to reflect new order
      queryClient.invalidateQueries({
        queryKey: ["compass-chat-history", variables.context_id],
      });
    },
    onError: (error) => {
      console.error("Failed to reorder actions:", error);
    },
  });
};
